import React from "react";
import Slider from "react-slick";
import { FaRegSmileBeam, FaPiggyBank, FaUsers, FaHandshake, FaHospitalUser, FaHeartbeat } from 'react-icons/fa';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
 

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  centerMode: true,
  centerPadding: '40px',
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 2, centerPadding: '30px' } },
    { breakpoint: 600, settings: { slidesToShow: 1, centerPadding: '20px' } }
  ],
  appendDots: dots => (
    <div>
      <ul style={{ margin: 0 }}>{dots}</ul>
    </div>
  ),

};

const slides = [
  {
    icon: <FaHandshake className="text-[#FFA800] text-5xl mx-auto mb-2" />,
    title: "REDE DE PARCERIAS",
    description: "Condições vantajosas em mais de 1300 parceiros e 3500 locais, com vantagens em spas, óticas, termas, cuidados domiciliários."
  },
  {
    icon: <FaUsers className="text-[#FFA800] text-5xl mx-auto mb-2" />,
    title: "PRÉMIO FAMÍLIA",
    description: "A partir de 3 pessoas seguras, o prémio não aumenta! Exemplo: para 4 pessoas fica 4,25€ por mês por pessoa."
  },
  {
    icon: <FaRegSmileBeam className="text-[#FFA800] text-5xl mx-auto mb-2" />,
    title: "UTILIZAÇÃO IMEDIATA",
    description: "Seguro de subscrição fácil, sem questionário clínico, sem preexistências, e sem idade limite de subscrição e de permanência."
  },
  {
    icon: <FaHeartbeat className="text-[#FFA800] text-5xl mx-auto mb-2" />,
    title: "PREVENÇÃO",
    description: "Consultas, exames e tratamentos de prevenção, sem copagamentos e sem valores a cargo da pessoa segura."
  },
  {
    icon: <FaPiggyBank className="text-[#FFA800] text-5xl mx-auto mb-2" />,
    title: "PRÉMIO FIXO*",
    description: "7,5€ para 1 pessoa\n13€ para 2 pessoas\n17€ para 3 ou mais."
  },
  {
    icon: <FaHospitalUser className="text-[#FFA800] text-5xl mx-auto mb-2" />,
    title: "PRESTADORES DE REFERÊNCIA",
    description: "Rede de prestadores selecionados com critérios de qualidade e inovação tecnológica."
  }
];

export default function CharmeSlider() {
  return (
    <div className="w-full bg-[#F0F1F3] py-12 px-6 overflow-hidden">
      <h2 className="text-center text-3xl font-bold mb-10 text-[#333]">Benefícios Multicare Dental</h2>
      <Slider {...sliderSettings}>
        {slides.map((slide, index) => (
 <div key={index} className="px-3">
  <div className="bg-white rounded-lg shadow-lg p-8 text-center flex flex-col items-center min-h-[380px]">
    <div className="mb-4">{slide.icon}</div>
    <h3 className="text-[#FFA800] text-xl font-bold mb-3">{slide.title}</h3>
    <p className="text-[#333] text-sm leading-relaxed">{slide.description}</p>
  </div>
</div>

        ))}
      </Slider>
    </div>
  );
}